import apiService from '../apiService'

const apiPath = '/notification'

export const notificationController = (configService) => {
	const service = apiService(configService)
	return {
		getNotificationsAll: () => {
			return service.get({
				url: `${apiPath}/get-notifications-all`,
			})
		},
	}
}
